import { render, staticRenderFns } from "./EmployeeDiscounts.vue?vue&type=template&id=538b2685&scoped=true"
import script from "./EmployeeDiscounts.vue?vue&type=script&lang=js"
export * from "./EmployeeDiscounts.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDiscounts.vue?vue&type=style&index=0&id=538b2685&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b2685",
  null
  
)

export default component.exports